import { useCallback, useState } from 'react';
import useApiCall from '../../../../hooks/useApiCall';
import { ClientUserBeingRemovedType } from '../../types';
import ClientUsersService from '../../../../services/ClientUsersService';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { toast } from 'react-toastify';

interface IUseDeleteClientUser {
  loadClientUsers: () => void;
}

interface IDeleteUser { clientUserCode: number }

export default function useDeleteInternalUser({ loadClientUsers }: IUseDeleteClientUser) {
  const [isDeletingClientUser, setIsDeletingClientUser] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [clientUserBeingRemoved, setClientUserBeingRemoved] = useState({} as ClientUserBeingRemovedType);

  const { apiCall } = useApiCall();
  const { userCode, userProfile, userName, companyCode } = useGetGeneralAppData();

  const deleteClientUser = useCallback(async ({ clientUserCode }: IDeleteUser) => {
    await apiCall({
      apiToCall: ClientUsersService.deleteClientUser,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        codUsuAcesso: clientUserCode,
      }),
      onStartLoad: () => setIsDeletingClientUser(true),
      onEndLoad: () => {
        setIsDeletingClientUser(false);
        setDeleteModalShow(false);
      },
      actionAfterResponse: (response) => {
        if (!response?.codigo) {
          toast.error('Não foi possível remover o usuário. Por favor, tente novamente');
          return;
        }
        toast.success('O usuário foi removido com sucesso');
        setDeleteModalShow(false);
        loadClientUsers();
      },
      catchMessage: 'Não foi possível remover o usuário, Por favor, tente novamente'
    });
  }, [apiCall, companyCode, loadClientUsers, userCode, userName, userProfile]);

  function handleOpenDeleteModal({ name, clientUserCode }: ClientUserBeingRemovedType) {
    setDeleteModalShow(true);
    setClientUserBeingRemoved({
      name,
      clientUserCode,
    });
  }

  return {
    isDeletingClientUser,
    deleteModalShow,
    clientUserBeingRemoved,
    deleteClientUser,
    handleOpenDeleteModal,
    setDeleteModalShow,
  };
}
